import script from "./sp-results-load-more.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./sp-results-load-more.vue?vue&type=script&setup=true&lang=ts"
export * from "./sp-results-load-more.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./sp-results-load-more.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__